// ---------------------------------------
// Set data endpoint based on environment
// ---------------------------------------
window.API = `http://${location.hostname}:5005`;

if (location.hostname == 'epha.health') {
  window.API = `https://api.epha.health`;
}
if (location.hostname == 'epha.io') {
  window.API = `https://api.epha.io`;
}

// --------------------------------
// Route /access manages token
// --------------------------------
exports.access = require('../common/access');

// --------------------------------
// Route /taxono
// --------------------------------
exports.simple = require('../common/simple');

// --------------------------------
// Route /status
// --------------------------------
exports.status = require('./status');

// --------------------------------
// Google Cloud on dev
// --------------------------------
exports.translate = require('../common/translate');

// --------------------------------
// Single route on aws lambda
// --------------------------------
exports.kinetic = require('./kinetic');

// --------------------------------
// Single route on aws lambda pdf
// --------------------------------
exports.pdf = require('./pdf');
